class CustomerAccountUIExtensionError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'CustomerAccountUIExtensionError';
  }
}
class ScopeNotGrantedError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'ScopeNotGrantedError';
  }
}
class ExtensionHasNoMethodError extends Error {
  constructor(method, target) {
    super(`Cannot call '${method}()' on target '${target}'. The corresponding property was not found on the API.`);
    this.name = 'ExtensionHasNoMethodError';
  }
}
class ExtensionHasNoFieldError extends Error {
  constructor(field, target) {
    super(`Cannot access '${field}' on target '${target}'. The corresponding property was not found on the API.`);
    this.name = 'ExtensionHasNoFieldrror';
  }
}

export { CustomerAccountUIExtensionError, ExtensionHasNoFieldError, ExtensionHasNoMethodError, ScopeNotGrantedError };
